module.exports = __webpack_public_path__ + "img/megaphone-mobile.e35cba12.png";